import request from '@/utils/request';
const base_path = '/adminOperationLogs';

/**
 * 获取后台操作日志列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getOperationLogListApi = (params) => {
  return request({
    url: base_path,
    method: 'get',
    params,
  });
};
